import React, { Component } from 'react';
import { func } from 'prop-types';
import moment from 'moment';
import styles from './infoBox.module.css';
import { surveySchemaPartType, surveyPartUsageType, surveyPartTypeValues } from '../../../constants/types';
import { getTranslation, withLang, langType } from '../../../i18n';
import { routes, DISPLAY_DATE_FORMAT } from '../../../constants';
import PopUpMenu from '../../PopUpMenu';
import { getCompiledPath, getSubRouteForSurveyType } from '../../../util';
import withRouter from '../../WithRouter';

class InfoBox extends Component {
  constructor(props) {
    super(props);
    this.navigateToSchema = this.navigateToSchema.bind(this);
    this.navigateToSurvey = this.navigateToSurvey.bind(this);
    this.buildPopUpMenu = this.buildPopUpMenu.bind(this);
  }

  navigateToSchema(surveySchemaId) {
    this.props.navigate(getCompiledPath(routes.surveySchemas.schemas.schema.index, { surveySchemaId }));
  }

  navigateToSurvey(surveyId, surveyType) {
    const surveyTypeRoute = getSubRouteForSurveyType(surveyType);
    this.props.navigate(getCompiledPath(surveyTypeRoute.survey.index, { surveyId }));
  }

  buildPopUpMenu({ surveySchemas, surveys }) {
    const t = this.props.translate;
    const menuItems = surveySchemas.map((schema) => ({
      action: () => this.navigateToSchema(schema.id),
      text: `${schema.code} – ${getTranslation(schema.title, this.props.lang)}`
    }))
      .concat(surveys.map((survey) => ({
        action: () => this.navigateToSurvey(survey.id, survey.type),
        text: `${t('common.survey')} ${survey.code} – ${getTranslation(survey.title, this.props.lang)}`
      })));
    return <PopUpMenu className={styles.usagePopUp} hostId="1" title="" menuItems={menuItems} />;
  }

  composeStatus(status, surveyPartUsage, t) {
    const schemaCount = surveyPartUsage.surveySchemas.length;
    const surveyCount = surveyPartUsage.surveys.length;
    const statusText = (surveyPartUsage.lockedFromEditing) ? t('status.IN_USE') : t(`status.${status}`);

    if (!schemaCount) {
      return (
        <div className={styles.statusText}>
          <p>{statusText}</p>
        </div>
      );
    }

    const surveyCountText = (surveyCount)
      ? `${surveyCount} ${t('manageSurveys.nSurveys')} ${t('common.and')} ` : '';
    const schemaCountText = `${schemaCount} ${t('manageSurveys.nSurveySchemas')}`;
    return (
      <div className={styles.statusText}>
        <p>{statusText} - {surveyCountText}{schemaCountText} {this.buildPopUpMenu(surveyPartUsage)}</p>
      </div>
    );
  }

  render() {
    const {
      surveyPart, surveyPartUsage, lang, translate
    } = this.props;
    const modDate = moment(surveyPart.lastModifiedDate).format(DISPLAY_DATE_FORMAT);
    return (
      <div className={styles.infoBox}>
        <div className={styles.row}>
          <div className={styles.label}><p>{translate('common.name')}</p></div>
          <div className={styles.info} data-cy="survey-part-common-name"><p>{getTranslation(surveyPart.title, lang)}</p></div>
        </div>
        <div className={styles.row}>
          <div className={styles.label}><p>{translate('surveyParts.identifier')} </p></div>
          <div className={styles.info} data-cy="survey-part-code"><p>{surveyPart.code}</p></div>
        </div>
        {surveyPart.type === surveyPartTypeValues.SURVEY_SCHEMA_PART && (
          <div className={styles.row}>
            <div className={styles.label}><p>{translate('common.version')}</p></div>
            <div className={styles.info} data-cy="survey-part-version"><p>{surveyPart.version}</p></div>
          </div>
        )}
        <div className={styles.row}>
          <div className={styles.label}><p>{translate('common.type')}</p></div>
          <div className={styles.info} data-cy="survey-part-type"><p>{surveyPart.surveyType ? translate(`surveyType.${surveyPart.surveyType}`) : '-'}</p></div>
        </div>
        <div className={styles.row}>
          <div className={styles.label}><p>{translate('manageSurveys.state')}</p></div>
          <div className={styles.info} data-cy="survey-part-status">
            {this.composeStatus(surveyPart.status, surveyPartUsage, translate)}
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.label}><p>{translate('common.modifiedAt')}</p></div>
          <div className={styles.info} data-cy="survey-part-modified-at">
            <p>{modDate} {surveyPart.lastModifiedBy}</p>
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.label}><p>{translate('common.description')}</p></div>
          <div className={styles.info} data-cy="survey-part-description"><p>{getTranslation(surveyPart.description, lang)}</p></div>
        </div>
      </div>
    );
  }
}
InfoBox.propTypes = {
  surveyPart: surveySchemaPartType.isRequired,
  surveyPartUsage: surveyPartUsageType.isRequired,
  navigate: func.isRequired,
  ...langType
};

export default withLang(withRouter(InfoBox));
